export const environment = {
    production: 'true',
    envName: 'ceupi',
    base: 'http://www.ceupi.edu.br',
    ceumaHost: 'https://www.ceupi.edu.br/novoportal',
    wpBaseUrl: 'https://www.ceupi.edu.br/ceupi-wordpress',
    //apiBaseUrl: 'http://localhost:8089/',
    apiBaseUrl: 'https://www.ceupi.edu.br',
    apiBaseKey: '25231f2bd30c3c3d490e1e9a03729f94',
    apiBasePath: '/vestibular-api-ceupi',
    // ******** VALOR DE URL BASE COMENTADO PARA TESTES LOCAIS *************************

    authPath:'https://www.extranet.ceuma.br',

    // *********************************************************************************
    //authPath: 'http://localhost:8088',
    authBasePath: '/authentication-api',

    // ******** VALOR DE URL BASE COMENTADO PARA TESTES LOCAIS *************************

    matrPath: 'https://www.extranet.ceuma.br',


    // *********************************************************************************
    //matrPath: 'http://localhost:8089/',
    // *****************************************************************************
    apiNotExtranet: 'http://www.ceupi.edu.br',
    recaptchaKey: '6LfI7aIUAAAAAF52dUXDLfsqjleq0kB-YHuhpbV-',
    analyticsKey: 'UA-47244799-1',
    checkoutKey: 'cd15694f775ae81cda5d336ec0948789',
    checkoutKeyPos: '93c5c81497dd2d2e6123d55dcdf366a4',
    baseHref: '/',
    // apiMatriPath: '/matricula-api'
    checkoutBasePath: '/checkout-api',
    loginContexto: 'CEUPI',
    validacaoDocumentosBasePath:'https://www.extranet.ceuma.br',
    // FLAGS
    flagPosGraduacao: 'false',
    flagPosGraduacao2ViaBoleto: 'false',
    flagRematricula: 'true',
    //Novos paths
    egressoPath: '/universidade/egressos',
    calendarioAcademicoPath: 'https://www.ceupi.edu.br/ceupi-wordpress/wp-content/uploads/2021/07/CALENDA%CC%81RIO-CEUPI-2021-1.pdf',
    calendarioAcademicoURLWP: 'https://www.ceupi.edu.br/ceupi-wordpress//wp-json/wp/v2/documentos?_embed=true&per_page=15&filter%5Bdocument_type%5D=calendario-academico',
    title: 'Faculdade Ceupi',
    rematriculaPath:'https://www.extranet.ceuma.br/matriculagalileo/',
    centralDoContratantePath: 'http://www.ceupi.edu.br/AreaDoContratante/login',
    posGraduacaoPath: undefined,
    extensaoPath: undefined,
    bibliotecaPath: 'http://www.ceuma.br/sitenovo/servicos_galileo/biblioteca/login.asp',
    // eadPath: 'https://ead.grupoceuma.com.br/',
    eadPath: 'http://ava.grupoceuma.com.br/',
    renovacaoBibliotecaPath:'http://www.ceupi.edu.br/sitenovo/servicos/biblioteca/login.asp',
    validacaoDocumentosPath:'https://www.ceupi.edu.br/ValidacaoDocumentos/',
    facebookPath:'https://www.facebook.com/CEUPIFaculdade/',
    twitterPath:'https://twitter.com/ceupi_oficial',
    youtubePath:'https://www.youtube.com/channel/UCekNKBFVySt4UmQjt5QHlDw',
    instagramPath:'https://www.instagram.com/ceupi_oficial/',
    loginPath: 'http://www.ceupi.edu.br/portalceupi/login/',
    //Variavel de habilitação de integração de declaração de veracidade do vestibular de medicina
    docmentoVeracidadeInfoMedic: false,
    /* Dados de pagamento */
    codigoServicoVestibular:99,
    codigoServicoMatricula:5,
    codigoSistemaVestibular:99,
    codigoSistemaMatricula:4,
    pathDeclaracao: null,
    pathMatriculaDigital: 'https://www.ceupi.edu.br/matricula-digital/',
    codigoCategoriaBiblioteca: '724'
  };


